import Color from '@tiptap/extension-color';

/**
 * Extended Color extension that applies color to list item markers (bullets/numbers).
 *
 * By default, TipTap's Color extension only colors text content, not the list markers.
 * This extension adds color support to listItem nodes so the ::marker pseudo-element
 *
 */

export const ColorExtended = Color.extend({
    addGlobalAttributes() {
        const parentAttributes = this.parent?.() || [];

        return [
            ...parentAttributes,
            {
                types: ['listItem'],
                attributes: {
                    color: {
                        default: null,
                        renderHTML: (attributes) => {
                            if (!attributes.color) {
                                return null;
                            }

                            return {
                                style: `color: ${attributes.color}`,
                            };
                        },
                    },
                },
            },
        ];
    },
});
